import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../../../util';

const table: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 300px)',
  width: '100%',
  overflow: 'auto',
  position: 'relative',
  '.selection__keyHandler': {
    overflow: 'visible',
    position: 'inherit',
  },
  // overflow: 'auto',
  // flexBasis: '100%',
  // wordBreak: 'break-word',
  // display: 'flex',
  // flexDirection: 'column',

  '.confirm__buttonBar': {
    display: 'flex',
    justifyContent: 'space-between',
    flexBasis: '40px',
    flexGrow: 0,
    flexShrink: 0,

    '.confirm__defaultButtons': {
      display: 'flex',
      gap: spacing(3),
    },
    '.confirm__customButtons': {
      width: 'auto',
    },
  },
};

export default table;
